import { PropTypes } from 'preact-compat';
import { createSelector } from 'reselect';
import { actionTypes } from '../actions';

// Prop Types (down)

export const mentionedProType = PropTypes.shape({
  avatarUrl: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});

// Prop Types (up)

// Constants (down)

export const moduleName = 'message';

// Constants (up)

// Reducer (down)

const initialState = {
  fetching: false,
  error: '',
  text: '',
  pros: [],
  personId: null,
};

export default function reducer(state = initialState, action) {
  const { error, type, payload } = action;

  switch (type) {
    case actionTypes.MESSAGE_SET_TEXT: {
      const { text } = payload;

      return {
        ...state,
        text,
      };
    }

    case actionTypes.MESSAGE_FETCH_PROS_AS_SUPPORT_REQUEST:
      return {
        ...state,
        fetching: true,
        pros: initialState.pros,
      };

    case actionTypes.MESSAGE_FETCH_PROS_AS_SUPPORT_SUCCESS: {
      const { pros } = payload;

      return {
        ...state,
        pros,
        fetching: false,
        error: initialState.error,
      };
    }

    case actionTypes.MESSAGE_FETCH_PROS_AS_SUPPORT_FAILURE:
      return {
        ...state,
        fetching: false,
        error: error || 'Cannot fetch referenced pros!',
        pros: initialState.pros,
      };

    case actionTypes.MESSAGE_RESET:
      return { ...initialState };

    case actionTypes.GET_USER_DETAILS_SUCCESS:
      return action.payload.id !== state.personId
        ? {
          ...initialState,
          personId: action.payload.id,
        }
        : { ...state };
    case actionTypes.RESET_USER_DETAILS:
      return {
        ...initialState,
      };

    default:
      return state;
  }
}

// Reducer (up)

// Selectors (down)

const stateSelector = (state) => state[moduleName];

export const selectMessageIsFetching = createSelector(
  stateSelector,
  (message) => message.fetching,
);

export const selectMessageError = createSelector(
  stateSelector,
  (message) => message.error,
);

export const selectMessageText = createSelector(
  stateSelector,
  (message) => message.text,
);

export const selectMessagePros = createSelector(
  stateSelector,
  (message) => message.pros,
);

// Selectors (up)



// WEBPACK FOOTER //
// ./reducers/message.js